module.exports = __webpack_public_path__ + "45b028b3976256faec5cc6abed926a50.pdf";